import { lazy, type ComponentType, type LazyExoticComponent } from 'react';
import type { ViewId } from '../router/useView';

// One lazy chunk per destination. Keys must cover every ViewId; the
// Record type makes a missing entry a compile error.
export const VIEW_COMPONENTS: Record<ViewId, LazyExoticComponent<ComponentType>> = {
  dashboard: lazy(() => import('./dashboard')),
  live: lazy(() => import('./live')),
  checker: lazy(() => import('./checker')),
  discover: lazy(() => import('./discover')),
  desk: lazy(() => import('./desk')),
  catalysts: lazy(() => import('./catalysts')),
  watchlists: lazy(() => import('./watchlists')),
  sources: lazy(() => import('./sources')),
  relationships: lazy(() => import('./relationships')),
  callers: lazy(() => import('./callers')),
  creators: lazy(() => import('./creators')),
  markets: lazy(() => import('./markets')),
  ledger: lazy(() => import('./ledger')),
  health: lazy(() => import('./health')),
  telegram: lazy(() => import('./telegram')),
  discord: lazy(() => import('./discord')),
  x: lazy(() => import('./x')),
  wallets: lazy(() => import('./wallets')),
  coach: lazy(() => import('./coach')),
  alerts: lazy(() => import('./alerts')),
  settings: lazy(() => import('./settings')),
};
